// extracted by css-extract-rspack-plugin
export default {"redirectNotice":"_e323acc5","searchSuggestions":"_18011254","collated":"_95222d9d","regular":"_b661d0ff","bottomModule":"_7638b230","holidayCollectionBreadcrumbs":"_7112c285"};